/* tslint:disable */
/* eslint-disable */
export enum EntityType {
  Store = 'STORE',
  StoreTax = 'STORE_TAX',
  Refund = 'REFUND',
  Cart = 'CART',
  Checkout = 'CHECKOUT',
  StoreAggPause = 'STORE_AGG_PAUSE',
  StoreOrdering = 'STORE_ORDERING',
  StoreQuantityLimit = 'STORE_QUANTITY_LIMIT',
  StoreAvailability = 'STORE_AVAILABILITY',
  StoreGroup = 'STORE_GROUP'
}
